import { api } from '../client';

export const coach = {
  ask: api.askCoach,
};
